module.exports = __webpack_public_path__ + "media/images/cable-bd2e4aece744f9b84a0683397176ce5c.jpeg";